import "./H1.scss"

export const H1 = ({ children = null, className = "", testid = "H1" }) => (
  <div
    className={`H1 maax-font-weight-black ${className}`}
    data-testid={testid}
  >
    {children}
  </div>
)

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// H1.propTypes = {
//   children: PropTypes.node,
//   className: PropTypes.string,
//   testid: PropTypes.string,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// H1.defaultProps = {
//   children: null,
//   className: "",
//   testid: "H1",
// }
